import type { ReactNode } from "react";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "../components/Spinner";
import { Layout } from "../components/Layout";
import { LandingPage } from "../pages/LandingPage";
import { LoginPage } from "../pages/LoginPage";
import { ChangePasswordPage } from "../pages/ChangePasswordPage";
import { DashboardPage } from "../pages/DashboardPage";
import { SettingsPage } from "../pages/SettingsPage";
import { NotFoundPage } from "../pages/NotFoundPage";

function FullScreen({ children }: { children: ReactNode }) {
  return <div className="flex h-full items-center justify-center">{children}</div>;
}

function RequireAuth() {
  const { status, mustChangePassword } = useAuth();
  if (status === "loading") {
    return (
      <FullScreen>
        <Spinner label="Loading" />
      </FullScreen>
    );
  }
  if (status === "anon") return <Navigate to="/login" replace />;
  if (mustChangePassword) return <Navigate to="/change-password" replace />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function ChangePasswordGate() {
  const { status, mustChangePassword } = useAuth();
  if (status === "loading") {
    return (
      <FullScreen>
        <Spinner label="Loading" />
      </FullScreen>
    );
  }
  if (status === "anon") return <Navigate to="/login" replace />;
  if (!mustChangePassword) return <Navigate to="/app" replace />;
  return <ChangePasswordPage />;
}

export const router = createBrowserRouter([
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/change-password", element: <ChangePasswordGate /> },
  {
    element: <RequireAuth />,
    children: [
      { path: "/app", element: <DashboardPage /> },
      { path: "/settings", element: <SettingsPage /> },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);
